import React from "react";

// import HeroSection from "../includes/NewHome/HeroSection";

// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";
// import ScrollyLayout from "../includes/NewHome/ScrollyLayout";
// import AboutUsSection from "../includes/NewHome/AboutUsSection";
// import WhatWeDoSection from "../includes/NewHome/WhatWeDoSection";
// import ServicesSection from "../includes/NewHome/ServicesSection";
import Home from "../includes/NewHomee/Homee";

const NewHome = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "exddigital.com",
    },
    headline: "ExD Digital - Digital Marketing & Custom Development Solutions",
    image: "https://www.exddigital.com/images/homepage/bg-section-1.webp",
    author: {
      "@type": "Organization",
      name: "ExD Digital",
      url: "https://www.exddigital.com",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.webp",
      },
    },
    datePublished: "2023-08-01",
    dateModified: "2023-08-02",
  };
  

  return (
    <>
      <Helmet>
        <title>
          Digital Marketing & Custom Development Solutions
        </title>
        <meta
          name="description"
          content="Book a demo to get more leads or grow your startups, e-commerce, or service businesses with 360° digital marketing services & custom web/app development solutions"
        />
        <link rel="canonical" href="https://www.exddigital.com/" />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="home-main">
        {/* <div className="snap-container">
            <HeroSection url={devUrl} />
            <ScrollyLayout>

                <AboutUsSection url={devUrl} />
                <ServicesSection url={devUrl} />

            </ScrollyLayout>
        </div> */}
    <Home />
      </main>
    </>
  );
};
export default React.memo(NewHome);
